import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import { Theme } from "@mui/material/styles";

import Box from "../Box";
import Typography from "../Typography";


const SidaNavBarProfile = (props: {
    sideNavItems: any[]
}) => {

    return (
        <Card
            key={`side_card`}
            sx={{
                top: "1%",
                position: "sticky",
                borderRadius: ({ borders: { borderRadius } }) => borderRadius.lg,
            }}
        >
            <Box
                m={0}
                p={2}
                component="ul"
                display="flex"
                flexDirection="column"
                sx={{ listStyle: "none" }}
            >
                {
                    props.sideNavItems.map(({ icon, label, href }, key) => (
                        <Box
                            component="li"
                            pt={key === 0 ? 0 : 1}
                            key={`item_side_nav_${key}`}
                        >
                            <Typography
                                component="a"
                                variant="button"
                                href={`#${href}`}
                                fontWeight="regular"
                                textTransform="capitalize"
                                sx={({ borders: { borderRadius }, functions: { pxToRem }, palette: { light }, transitions }: Theme) => ({
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: borderRadius.md,
                                    padding: `${pxToRem(10)} ${pxToRem(16)}`,
                                    transition: transitions.create("background-color", {
                                        easing: transitions.easing.easeInOut,
                                        duration: transitions.duration.shorter,
                                    }),

                                    "&:hover": {
                                        backgroundColor: light.main,
                                    },
                                })}>
                                <Box mr={1.5} lineHeight={1}>
                                    <Icon fontSize="small">{icon}</Icon>
                                </Box>
                                {label}
                            </Typography>
                        </Box>
                    ))
                }
            </Box>
        </Card>
    );
}

export default SidaNavBarProfile;
